import { useEffect, useState } from "react";
import { CONST_DNI, CONST_ROL_MASTER } from "../../../../app/constants/constanst-valores";
import { usuarioObtenerCompaniasYSucursales } from "../../api/usuarios.api";
import { sedesPorCompania } from "../../../sedes";
import { sucursalesPorCompania } from "../../../sucursales";

// Catálogos del formulario de usuario (compañías, sucursales y árbol de sedes),
// longitud del número de documento y carga inicial al montar.
export const useUsuarioFormCatalogos = ({
    usuarioAutenticado,
    rol,
    usuario,
    compania,
    accion,
    watch,
    setValue,
    setListaCompanias,
    setListaSucursales,
    setListaSedes,
    setSedesSeleccionadas,
    setValorSeleccionado,
}: any) => {

    // token?: acepta (e ignora) el argumento que pasa cargarDatosIniciales;
    // el valor real se lee del closure `usuarioAutenticado`. Runtime sin cambios.
    const obtenerCompaniasYSucursales = async (token?: any) => {

        const dataPOST = {
            token: usuarioAutenticado?.token
        }

        const { companias, sucursales, sedes } = await usuarioObtenerCompaniasYSucursales(dataPOST)
        setListaCompanias(companias)
        setListaSucursales(sucursales)
        //setValue("compania", usuario?.UseCompPad || companias?.[0]?.id)
        setValue("compania", usuario?.UseCompPad || compania)

        return {
            companias:compania,
            sucursales:sucursales,
            sedes:sedes
        }
    }

    const obtenerSucursalesPorCompania = async (idCompania) => {

        if (idCompania) {
            const dataPOST = {
                token: usuarioAutenticado?.token,
                Codigo: idCompania,
                Estado: "A"
            }
            const { sucursales } = await sucursalesPorCompania(dataPOST)
            //console.log(sucursales)
            setListaSucursales(sucursales)
            //setValue("sucursal", usuario?.UseComp || sucursales?.[0]?.CompCod)
            setValue("sucursal", usuario?.UseComp || "")


        }
    }

    // Multi Sede Usuarios: selección inicial en EDICIÓN — detalle `usuario.sedes`
    // (TMUSE20, lo devuelve MostrarUsuario) o, si no existe aún, la sede única
    // legacy `usuario.SedCod`.
    const construirSeleccionInicial = (sedes) => {
        // Toma la etiqueta de la opción del árbol (incluye "SUCURSAL — SEDE") si existe;
        // si no, cae a la descripción del detalle o un genérico.
        const etiqueta = (cod, fallback) => {
            const opt = sedes?.find(e => String(e?.SedCod) === String(cod))
            return opt?.SedDesc || fallback
        }
        if (Array.isArray(usuario?.sedes) && usuario.sedes.length > 0) {
            return usuario.sedes.map(s => ({
                value: s?.SedCod,
                label: etiqueta(s?.SedCod, s?.SedDesc || `Sede ${s?.SedCod}`)
            }))
        }
        if (usuario?.SedCod) {
            return [{ value: usuario.SedCod, label: etiqueta(usuario.SedCod, `Sede ${usuario.SedCod}`) }]
        }
        return []
    }

    // MULTI-SEDE ÁRBOL (2026-09-01): el picker carga TODAS las sedes del ÁRBOL de la
    // compañía padre (todas las sub-compañías), etiquetadas por sucursal, para poder
    // configurar usuarios que ven sedes de VARIAS sub-compañías (multi-vista). El
    // parámetro ya no acota la fuente (que es el árbol); solo indica si se precarga la
    // selección del usuario (carga inicial de EDITAR). Al cambiar de sucursal NO se
    // limpia la selección (el árbol es el mismo → se conserva lo ya elegido).
    const obtenerSedesPorSucursal = async (_idSucursal, precargarSeleccion = false) => {
        const compPadre = watch("compania") || usuario?.UseCompPad

        if (compPadre) {
            const dataPOST = {
                compania: 'T',
                comp_pad: compPadre,
                token: usuarioAutenticado?.token
            }
            const { sedes } = await sedesPorCompania(dataPOST)

            // "SUCURSAL — SEDE": distingue sedes homónimas de distintas sub-compañías.
            const opciones = (sedes || []).map(s => ({
                ...s,
                SedDesc: s?.sucursal_nom ? `${s.sucursal_nom} — ${s?.SedDesc}` : s?.SedDesc
            }))
            setListaSedes(opciones)
            if (precargarSeleccion) setSedesSeleccionadas(construirSeleccionInicial(opciones))
        } else {
            setSedesSeleccionadas([])
            setListaSedes([])
        }
    }

    const [maxLengthInput, setMaxLengthInput] = useState(8)

    const handleInputChange = (e) => {
        let inputValue = e.target.value.trim(); // Eliminar espacios en blanco al inicio y al final

        if (watch("tipo_ide") === "D") {
            // Filtrar caracteres no numéricos cuando tipo_ide es "D"
            inputValue = inputValue.replace(/[^0-9]/g, "");
        }

        // Limitar la longitud del valor (sin contar espacios)
        if (inputValue.length > maxLengthInput) {
            inputValue = inputValue.slice(0, maxLengthInput);
        }

        e.target.value = inputValue;
    };

    const cambiarTipoDocumento = () => {
        if (watch("tipo_ide") === "D") {
            setMaxLengthInput(8)
        } else {
            setMaxLengthInput(12)
        }
    }

    useEffect(() => {

        const cargarDatosIniciales = async () => {

            const { sucursales, sedes } = await obtenerCompaniasYSucursales(usuarioAutenticado?.token)

            if (rol === CONST_ROL_MASTER) {

                await obtenerSucursalesPorCompania(watch("compania"));
                await obtenerSedesPorSucursal(watch("sucursal"), accion === "editar");
            } else {
                const listaSucursalesFormateada = sucursales?.map(s => ({
                    CompCod: s?.id,
                    CompNom: s?.tipo
                }))

                setListaSucursales(listaSucursalesFormateada)
                if(accion === "editar"){

                    setValorSeleccionado(usuario.UseComp)
                    setValue("sucursal", usuario?.UseComp)
                }else{
                    setValorSeleccionado("disabled")
                    setValue("sucursal", "")
                }
                //setValue("sucursal", listaSucursalesFormateada?.[0]?.CompCod)
            }
            if (sucursales?.length > 1) {

                await obtenerSedesPorSucursal(watch("sucursal"), accion === "editar");
            } else {

                const listaSedesFormateada = sedes?.map(s => ({
                    SedCod: s?.id,
                    SedDesc: s?.tipo
                }))
                setListaSedes(listaSedesFormateada)
                if(accion === "editar"){
                    // Multi Sede Usuarios: precarga el detalle (o la sede única legacy)
                    setSedesSeleccionadas(construirSeleccionInicial(listaSedesFormateada))
                }
            }

        };

        cargarDatosIniciales();
        setValue("tipo_ide", usuario?.UseTIde || CONST_DNI);
        // carga inicial (una sola vez al montar)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        obtenerSucursalesPorCompania,
        obtenerSedesPorSucursal,
        maxLengthInput,
        handleInputChange,
        cambiarTipoDocumento,
    }
}
